import { render, staticRenderFns } from "./resultReport.vue?vue&type=template&id=6e18685a"
import script from "./resultReport.vue?vue&type=script&lang=js"
export * from "./resultReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e18685a')) {
      api.createRecord('6e18685a', component.options)
    } else {
      api.reload('6e18685a', component.options)
    }
    module.hot.accept("./resultReport.vue?vue&type=template&id=6e18685a", function () {
      api.rerender('6e18685a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/pca/result/resultReport.vue"
export default component.exports